/* Shared, language-independent config.
Translated content (greeting, experience, education, projects, skills, achievements, contact)
now lives in src/content/en.js and src/content/de.js, selected via LanguageContext. */

import splashAnimation from "./assets/lottie/splashAnimation";

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/talal02",
  linkedin: "https://www.linkedin.com/in/talal02/",
  gmail: "talalahmed252@gmail.com",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Blogs Section (unused, kept so legacy containers keep compiling)

const blogSection = {
  title: "Blogs",
  subtitle: "",
  displayMediumBlogs: "false",
  blogs: [],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections (unused, kept so legacy containers keep compiling)

const talkSection = {
  title: "TALKS",
  subtitle: "",
  talks: [],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section (unused, kept so legacy containers keep compiling)

const podcastSection = {
  title: "Podcast",
  subtitle: "",
  podcast: [],
  display: false // Set false to hide this section, defaults to true
};

// Twitter Section (unused, kept so legacy containers keep compiling)

const twitterDetails = {
  userName: "t_alal02",
  display: false // Set true to display this section, defaults to false
};

export {
  illustration,
  splashScreen,
  socialMediaLinks,
  blogSection,
  talkSection,
  podcastSection,
  twitterDetails
};
